import {
  Box,
  Button,
  TableFooter,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ArrowBackButton from "../../../../Base/views/ArrowBackButton";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../../../css/styles.css";
import { toast } from "react-toastify";
import {
  GetMyTimeSheetInfo,
  GetMyTimeSheetLeaveInfoHelper,
  GetWeekdatesHelper,
  GetWeekdaysHelper,
} from "../../../helper/TimeSheet/MyTimeSheetHelper";
import {
  AddMyTimeSheetAction,
  UpdateMyTimeSheetAction,
} from "../../../../../../store/Leave/MyTimeSheet/Action";
import { ApproveTimeSheetAction } from "../../../../../../store/Leave/MyTeam/Action";
import Popup from "../../../../Base/views/Popup";
import ApplyLeave from "../TimeOff/ApplyLeave";
import { getUserData } from "../../../../Base/helper/baseFunctions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
  "&.total": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, sun, mon, tue, wed, thu, fri, sat) {
  return { name, sun, mon, tue, wed, thu, fri, sat };
}
const headers = [
  "Project Task",
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Total",
];
const columnNames = ["name", "mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const rows = [createData("", "", "", "", "", "", "", "")];
let final;
const calculateTotal = (row) => {
  const numericValues = Object.values(row).map((value) => {
    const parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? 0 : parsedValue; // Treat NaN values as 0
  });
  final = numericValues.reduce((total, value) => total + value, 0);
  return numericValues.reduce((total, value) => total + value, 0);
};

const MyTimeSheetForm = ({ setFormMode, tableData, setSuccessMode, setTableData, isReopened}) => {
  const dispatch = useDispatch();
  const empData = getUserData();
  const [disabledFieldsMap, setDisabledFieldsMap] = useState({});
  const allDaysDisabled = Object.values(disabledFieldsMap).every(val => val === true);
  const [rowData, setRowData] = useState(rows);
  const [Id, setId] = useState();
  const [projectHours, setProjectHours] = useState({});
  const [helperProjectHours, setHelperProjectHours] = useState({});
  const [employeeLeaveHr, setEmployeeLeaveHr] = useState(0)
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [weekData, setWeekData] = useState();
  const [isGetLoading, SetisGetLoading] = useState(true);
  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = useState("");
  const [date, setDate] = useState();
  const [success1, setSuccess1] = useState(false);
  const [data, setData] = useState({});
  const { dashboardData } = useSelector(
    (state) => state?.EmployeeDashboardReducer
  );
  const { getSuccess, button_disable, error } = useSelector(
    (state) => state?.LeaveReducer?.MyTimeSheetReducer
  );
  const { GetSuccess } = useSelector(
    (state) => state?.LeaveReducer?.TimeSheetApprovalReducer
  );
  const [employeeLeave, setEmployeeLeave] = useState({});
  const parseCustomDate = (dateStr) => {
    const cleanStr = dateStr.replace(/-/g, '').replace(/\s+\w{3}$/, '').trim();
    const date = new Date(cleanStr);

    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };
  const updateRowData = (rowData,mergedProjectHours, empHr) => { // update Row Data to overwrite the leaves days to 0
    const updatedRow = { ...rowData };
    for (const day in mergedProjectHours) {
      if (Number(mergedProjectHours[day]) === Number(empHr/2)) {
        updatedRow[day] = Number(empHr/2).toFixed(2);
      } else if (mergedProjectHours[day] > 0) {
        updatedRow[day] = "0.00";
      }
    }
    return updatedRow
  };
  const handleHolidayCall = (updRow) => {
    const start_date = new Date(tableData?.start_date);
    const start_date_day = start_date.getDate();
    const start_date_month = start_date.getMonth() + 1;
    const start_date_year = start_date.getFullYear();

    const end_date = new Date(tableData?.end_date);
    const end_date_day = end_date.getDate();
    const end_date_month = end_date.getMonth() + 1;
    const end_date_year = end_date.getFullYear();
    GetMyTimeSheetLeaveInfoHelper({
      from_date_day: start_date_day,
      from_date_month: start_date_month,
      from_date_year: start_date_year,
      to_date_day: end_date_day,
      to_date_month: end_date_month,
      to_date_year: end_date_year,
    }).then((res) => {
      if (!res?.data?.data?.[0]?.leave_hours) {
        toast.error("Work hours not set. Please contact your manager.");
      }
      const perhLeaveInfo = res?.data?.data?.[0]?.perh_leave_info || [];
      const phLeaveInfo = res?.data?.data?.[0]?.ph_leave_info || [];
      
      setEmployeeLeaveHr(res?.data?.data?.[0]?.leave_hours)
      const mergedProjectHours = {};
      perhLeaveInfo.forEach((info) => {
        if (info.day_of_week) {
          mergedProjectHours[info.day_of_week] = info.project_hours ?? 0;
        }
      });
      phLeaveInfo.forEach((info) => {
        if (info.day_of_week) {
          if (!(Number(mergedProjectHours[info.day_of_week]) > 0)) {
            mergedProjectHours[info.day_of_week] = info.project_hours ?? 0;
          }
        }
      });
      setProjectHours(mergedProjectHours);
      setHelperProjectHours(mergedProjectHours);
      const updatedRowData = updateRowData(updRow, mergedProjectHours, res?.data?.data?.[0]?.leave_hours)
      setRowData([updatedRowData])

      perhLeaveInfo.forEach((info) => {
        if (info.day_of_week) {
          setEmployeeLeave((prevState) => ({
            ...prevState,
            [info.day_of_week]: info.project_hours ?? 0,
          }))
        }
      });
    });
  }
  const daysOfWeek = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const rowTotal = daysOfWeek?.reduce(
    (total, day) => total + parseInt(projectHours[day] || 0),
    0
  );
  const handleInputChange = (event, rowIndex, columnIndex, columnName) => {
    const newValue = Number(event?.target?.value);
    if(newValue < 0) return;    
    const NewArry = [...rowData];
    const rowVal = NewArry[rowIndex];
    if(helperProjectHours[columnName] > 0) {
      const projHr = {...projectHours}
      const valSum =  Number(employeeLeaveHr) - Number(event?.target?.value)
      projHr[columnName] = valSum > 0 ? String(valSum) : "0"
      setProjectHours(projHr)
    }
    rowVal[columnName] = event?.target?.value;
    const newErrors = { ...errors };
    delete newErrors[`row_${columnName}`];
    setErrors(newErrors);
    setRowData(NewArry);
  };

   // not using as the field is disabled
  const handleHolidayInputChange = (event, rowIndex, day) => {
    const newProjectHours = { ...projectHours };
    newProjectHours[day] = event.target.value;
    const newErrors = { ...errors };
    delete newErrors[`projectHours_${day}`];
    setErrors(newErrors);
    setProjectHours(newProjectHours);
    setHelperProjectHours(newProjectHours);
  }
  useEffect(() => {
  const fetchData = async () => {
    try {
    setProjectHours({});
    setHelperProjectHours({});
    const start_date = new Date(tableData?.start_date);
    const start_date_day = start_date.getDate();
    const start_date_month = start_date.getMonth() + 1;
    const start_date_year = start_date.getFullYear();
    const end_date = new Date(tableData?.end_date);
    const end_date_day = end_date.getDate();
    const end_date_month = end_date.getMonth() + 1;
    const end_date_year = end_date.getFullYear();
    const weekDaysRes = await GetWeekdaysHelper({
      start_date_day: start_date_day,
      start_date_month: start_date_month,
      start_date_year: start_date_year,
    })
    setWeekData(weekDaysRes?.data?.data);
    const weekDatesRes = await GetWeekdatesHelper({
      start_date_day: start_date_day,
      start_date_month: start_date_month,
      start_date_year: start_date_year,
      end_date_day: end_date_day,
      end_date_month: end_date_month,
      end_date_year: end_date_year,
    });
    setDate(weekDatesRes?.data?.data?.[0]?.fn_map_days_to_dates);
    const weekDates = weekDatesRes?.data?.data?.[0]?.fn_map_days_to_dates || [];
    const empDojDate = new Date(empData?.doj);
    const empDoj = new Date(empDojDate.getFullYear(), empDojDate.getMonth(), empDojDate.getDate());
    const dayToDateMap = {
      mon: weekDates[0],
      tue: weekDates[1],
      wed: weekDates[2],
      thu: weekDates[3],
      fri: weekDates[4],
      sat: weekDates[5], 
      sun: weekDates[6],
    };
    const disabledMap = {};
    Object.keys(dayToDateMap).forEach((day) => {
      const dateStr = dayToDateMap[day];
      const parsedDate = parseCustomDate(dateStr);
      disabledMap[day] = parsedDate < empDoj;
    });
    setDisabledFieldsMap(disabledMap);
    if (tableData?.flag === "Approved" || tableData?.flag === "Rejected" || tableData?.flag === "Submitted") {
      const updatedRow = {
        name: tableData?.project_code || "",
        mon: Number(tableData?.weekly_hour?.PROJECTCODE?.mon || 0).toFixed(2),
        tue: Number(tableData?.weekly_hour?.PROJECTCODE?.tue || 0).toFixed(2),
        wed: Number(tableData?.weekly_hour?.PROJECTCODE?.wed || 0).toFixed(2),
        thu: Number(tableData?.weekly_hour?.PROJECTCODE?.thu || 0).toFixed(2),
        fri: Number(tableData?.weekly_hour?.PROJECTCODE?.fri || 0).toFixed(2),
        sat: Number(tableData?.weekly_hour?.PROJECTCODE?.sat || 0).toFixed(2),
        sun: Number(tableData?.weekly_hour?.PROJECTCODE?.sun || 0).toFixed(2),
      };
      setRowData([updatedRow]);
        const leaveInfoRes = await  GetMyTimeSheetLeaveInfoHelper({
          from_date_day: start_date_day,
          from_date_month: start_date_month,
          from_date_year: start_date_year,
          to_date_day: end_date_day,
          to_date_month: end_date_month,
          to_date_year: end_date_year,
          mytime_configure_id: tableData?.mytime_configure_pk,
        });
        const perhLeaveInfo = leaveInfoRes?.data?.data?.[0]?.perh_leave_info || [];
        perhLeaveInfo.forEach((info) => {
          if (info.day_of_week) {
            setEmployeeLeave((prevState) => ({
              ...prevState,
              [info.day_of_week]: info.project_hours ?? 0,
            }))
          }
        });
      setEmployeeLeaveHr(leaveInfoRes?.data?.data?.[0]?.leave_hours)
      const projectHours = {};
      daysOfWeek.forEach((day) => {
        projectHours[day.substring(0, 3).toLowerCase()] =
          tableData?.weekly_hour?.LEAVECODE?.[
          day.substring(0, 3).toLowerCase()
          ] || 0;
      });
      setProjectHours(projectHours);
      setHelperProjectHours(projectHours)

    }
    else {
    const res  = await GetMyTimeSheetInfo();
    const updatedRow = {
      name: "",
      mon: Number(res?.data?.data?.[0]?.working_days_json?.["1"] || 0).toFixed(2),
      tue: Number(res?.data?.data?.[0]?.working_days_json?.["2"] || 0).toFixed(2),
      wed: Number(res?.data?.data?.[0]?.working_days_json?.["3"] || 0).toFixed(2),
      thu: Number(res?.data?.data?.[0]?.working_days_json?.["4"] || 0).toFixed(2),
      fri: Number(res?.data?.data?.[0]?.working_days_json?.["5"] || 0).toFixed(2),
      sat: Number(res?.data?.data?.[0]?.working_days_json?.["6"] || 0).toFixed(2),
      sun: Number(res?.data?.data?.[0]?.working_days_json?.["7"] || 0).toFixed(2),
    };
    handleHolidayCall(updatedRow)
    }
    } finally  {
        SetisGetLoading(false);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validate = () => {
    let isValid = true;
    const tempErrors = {};
    rowData.forEach((row, rowIndex) => {
      Object.entries(row).forEach(([day, hours]) => {
        if(day !== "name"){
          if (typeof hours !== "string" || hours?.trim() === "" || isNaN(hours) || Number(hours) < 0 ) {
            isValid = false;
            tempErrors[`row_${day}`] =
              "This field is required.";
          }
        }
      });
    });

    setErrors(tempErrors); // Update state with errors
    return isValid;
  };
  const handleAdd = () => {
    if (validate()) {
      const start_date = new Date(tableData?.start_date);
      const from_date_day = start_date.getDate();
      const from_date_month = start_date.getMonth() + 1;
      const from_date_year = start_date.getFullYear();
      const end_date = new Date(tableData?.end_date);
      const to_date_day = end_date.getDate();
      const to_date_month = end_date.getMonth() + 1;
      const to_date_year = end_date.getFullYear();
      const PROJECTCODE = Object.assign({}, rowData[0]);
      delete PROJECTCODE.name;
      const LEAVECODE = {};
      daysOfWeek.forEach((day) => {
        LEAVECODE[day] = disabledFieldsMap[day] ? "0" : (projectHours[day] || "0");
        PROJECTCODE[day] = disabledFieldsMap[day] ? "0" : (PROJECTCODE[day] || "0");
      });
        const weekly_working_days = JSON.stringify({ PROJECTCODE, LEAVECODE });
        if (tableData?.flag === "Reopened" || tableData?.flag === "Rejected") {
          dispatch(
            UpdateMyTimeSheetAction({
              from_date_day: from_date_day,
              from_date_month: from_date_month,
              from_date_year: from_date_year,
              to_date_day: to_date_day,
              to_date_month: to_date_month,
              to_date_year: to_date_year,
              week_no: parseInt(weekData?.[0]?.week_no_pk),
              weekly_working_days: weekly_working_days,
              manager_emp_id:
                dashboardData?.[0]?.reporting_manager_info?.[0]?.Id,
              mytime_configure_id: Id || tableData?.mytime_configure_pk,
            })
          );
        } else {
          dispatch(
            AddMyTimeSheetAction({
              from_date_day: from_date_day,
              from_date_month: from_date_month,
              from_date_year: from_date_year,
              to_date_day: to_date_day,
              to_date_month: to_date_month,
              to_date_year: to_date_year,
              week_no: parseInt(weekData?.[0]?.week_no_pk),
              weekly_working_days: weekly_working_days,
              manager_emp_id:
                dashboardData?.[0]?.reporting_manager_info?.[0]?.Id,
              mytime_configure_id: Id,
            })
          );
        }
    }
  };
  useEffect(() => {
    if (getSuccess === 200) {
      setFormMode("card");
      setSuccessMode(true);
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSuccess]);
  const handleBookClick = () => {
    setOpenPopup(true);
  };
  const getEventColor = (status) => {
    switch (status) {
      case "Approved":
        return "#20e277";
      case "Submitted":
        return "#20e277";
      case "Rejected":
        return "#e68d45";
      case "Reopened":
        return "#fbeae8";
      default:
        return "#94b2d1";
    }
  };

  const handleReOpen = (status) => {
    setShowComments(true);
    setData({
      flag: status,
      week_no: tableData?.week_no_pk,
      weekly_working_days: JSON.stringify(tableData?.weekly_hour),
      timesheet_id: tableData?.timesheet_pk,
      comments: comments,
      employee_id: tableData?.employee_pk,
    });
  };

  const handleConfirm = () => {
    data["comments"] = comments;
    dispatch(ApproveTimeSheetAction(data));
    setSuccess1(true);
  };
  useEffect(() => {
    if (GetSuccess === 200 && success1) {
      setShowComments(false);
      setComments("");
      setTableData(prevData => ({
        ...prevData,
        flag: data.flag
      }));
    }
    //eslint-disable-next-line
  }, [GetSuccess, success1]);

  useEffect(() => {
    if (error) {
      toast.error("Something went wrong. Please try again.")
    }
  }, [error])
  return (
    <>
      {isGetLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Box
        sx={{
          padding: "10px 0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            "@media (max-width: 600px)": {
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "start",
            },
          }}
        >
          <ArrowBackButton
            onClick={() => {
              setFormMode("card");
              setSuccessMode(true);
            }}
          />
          <Typography sx={{ padding: "10px" }} variant="h4">
            {tableData?.start_date} - {tableData?.end_date}
          </Typography>
        </Box>
        <Box></Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              background: getEventColor(tableData?.flag),
              fontWeight: 500,
              color: "#000",
              fontSize: "12px",
              padding: "8px 10px",
              borderRadius: "50px",
              width: "fit-content",
              marginTop: "10px",
            }}
          >
            {tableData?.flag}
          </Box>
          <Typography sx={{ padding: "10px", marginTop: "10px" }}>
            Due on {tableData?.due_date}
          </Typography>
        </Box>
        <Box sx={{ marginTop: "20px" }}>
          <Button
            sx={{
              fontWeight: 700,
              borderRadius: "8px",
              fontSize: "13px",
              height: "30px",
              padding: "4px 10px",
              boxShadow: "none",
              lineHeight: 1.71429,
              marginRight: "10px",
            }}
            size="small"
            variant="contained"
            className="mpl-primary-btn"
            onClick={handleAdd}
            disabled={
              tableData?.flag === "Approved" || tableData?.flag === "Submitted" || button_disable || allDaysDisabled
            }
          >
            {isReopened || tableData?.flag === "Reopened" ? "Resubmit for Approval" : "Submit for Approval"}
          </Button>
          <Button
            sx={{
              fontWeight: 700,
              borderRadius: "8px",
              fontSize: "13px",
              height: "30px",
              padding: "4px 10px",
              boxShadow: "none",
              lineHeight: 1.71429,
            }}
            onClick={() => handleBookClick()}
            size="small"
            variant="contained"
            className="mpl-primary-btn"
          >
            Book TimeOff
          </Button>

          {(tableData?.flag === "Submitted" || tableData?.flag === "Approved") && (
            <Button
              sx={{
                fontWeight: 700,
                borderRadius: "8px",
                fontSize: "13px",
                height: "30px",
                padding: "4px 10px",
                boxShadow: "none",
                lineHeight: 1.71429,
                margin: "0px 12px",
              }}
              size="small"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleReOpen("Reopened")}
            >
              Re-open
            </Button>
          )}
        </Box>

        <Popup
          fullWidth={true}
          maxWidth="lg"
          title="Book TimeOff"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <ApplyLeave setOpenPopup={setOpenPopup} />
        </Popup>
      </Box>
      <Box sx={{ marginTop: "20px" }}>
        <Typography sx={{ padding: "10px" }} variant="h4">
          Time Distribution
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell
                sx={{ width: "100px", padding: "16px 16px 16px 30px" }}
                align="left"
              >
                Activity
              </StyledTableCell>
              {date?.map((header, index) => (
                <StyledTableCell align="center" key={index}>
                  {header}
                </StyledTableCell>
              ))}
              <StyledTableCell sx={{ width: "60px" }} align="center">
                Total
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {Object.values(row).map((value, columnIndex) => (
                  <StyledTableCell
                    sx={{
                      width:
                        headers[columnIndex] === "Project Task"
                          ? "100px"
                          : "95px",
                    }}
                    key={columnIndex}
                  >
                    {headers[columnIndex] === "Project Task" ? (
                      <>
                        <TableCell
                          sx={{ width: "100px", padding: "16px 16px 16px 16px" }}
                          align="left"
                        >
                          Working Hours
                        </TableCell>
                      </>
                    ) : (
                      <TextField
                        className="centered-text-input"
                        value={value}
                        inputProps={{ min: 0 }}
                        onChange={(event, value) =>{
                          const newValue = Number(event?.target?.value);
                          const maxLimit = Number(employeeLeaveHr / 2);
                          const currentLeave = Number(employeeLeave[columnNames[columnIndex]]);
                          if (
                            currentLeave === maxLimit &&
                            newValue > maxLimit
                          ) {
                            return;
                          }
                          handleInputChange(
                            event,
                            rowIndex,
                            columnIndex,
                            columnNames[columnIndex]
                          )
                        }}
                        type="number"
                        error={!!errors[`row_${columnNames[columnIndex]}`]}
                        disabled={
                          (employeeLeave[columnNames[columnIndex]] > (employeeLeaveHr/2)) ||
                          tableData?.flag === "Approved" ||
                          tableData?.flag === "Submitted" || disabledFieldsMap[columnNames[columnIndex]]
                        }
                        helperText={errors[`row_${columnNames[columnIndex]}`]}
                      />
                    )}
                  </StyledTableCell>
                ))}
                <TableCell align="center">{Number(calculateTotal(row))?.toFixed(2)}</TableCell> 
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              backgroundColor: "#8b44ff !important",
              color: "#fff",
            }}
          >
            <TableRow>
              <StyledTableCell
                sx={{ width: "100px", padding: "16px 16px 16px 30px" }}
                align="left"
              >
                Time Off
              </StyledTableCell>
              {date?.map((day) => (
                <StyledTableCell align="center">{day}</StyledTableCell>
              ))}
              <StyledTableCell sx={{ width: "60px" }} align="center">
                Total
              </StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell
                sx={{ width: "100px", padding: "16px 16px 16px 30px" }}
                align="left"
              >
                Leave/Holiday
              </TableCell>
              {daysOfWeek?.map((day, rowIndex) => (
                <TableCell sx={{ width: "95px" }} align="center">
                  <TextField
                    className="centered-text-input"
                    value={projectHours[day] === "" || isNaN(Number(projectHours[day])) ? "" : Number(projectHours[day]).toFixed(2)}
                    type="number"
                    onChange={(event, value) => {
                      handleHolidayInputChange(
                        event,
                        rowIndex,
                        day
                      )
                    }
                    }
                    InputProps={{
                      style: {
                        fontWeight: projectHours[day] > 0 ? 'bold' : 'normal',
                      },
                    }}
                    disabled
                    error={!!errors[`projectHours_${day}`]}
                    helperText={errors[`projectHours_${day}`]}
                  />
                </TableCell>
              ))}
              <TableCell sx={{ width: "60px" }} align="center">
                {Number(rowTotal)?.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
          <TableFooter
            sx={{
              backgroundColor: "#8b44ff !important",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#8b44ff !important",
              },
            }}
          >
            <StyledTableCell
              sx={{
                width: "100px",
                color: "#fff",
                padding: "16px 16px 16px 30px",
              }}
              align="left"
            >
              Total
            </StyledTableCell>
            {daysOfWeek?.map((day) => (
              <StyledTableCell
                sx={{
                  width: "95px",
                  color: "#fff",
                  padding: "16px 16px 16px 16px !important",
                }}
                align="center"
              >
                {Number(rowData?.[0][day]) && Number(projectHours[day])
                  ? Number(projectHours[day])?.toFixed(2)
                  : (Number(rowData?.[0][day]) + Number(projectHours[day] || 0))?.toFixed(2)}
              </StyledTableCell>
            ))}
            <StyledTableCell sx={{ color: "#fff" }} align="center">
              {(rowTotal + final || 0)?.toFixed(2)}{" "}
            </StyledTableCell>
          </TableFooter>
        </Table>
      </TableContainer>
      <Popup
        title="Comments"
        openPopup={showComments}
        setOpenPopup={setShowComments}
        fullWidth={true}
      >
        <TextField
          autoFocus={false}
          size="small"
          multiline
          rows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          variant="outlined"
          fullWidth
          id="comments"
          label="Comments"
          name="comments"
        />
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            className="mpl-primary-btn"
            sx={{ marginTop: "1.75rem" }}
            onClick={handleConfirm}
          >
            Save
          </Button>
        </Box>
      </Popup>
    </>
  );
};

export default MyTimeSheetForm;
